import { render, staticRenderFns } from "./ServiceBreakdownCard.vue?vue&type=template&id=9615755c&scoped=true"
import script from "./ServiceBreakdownCard.vue?vue&type=script&lang=js"
export * from "./ServiceBreakdownCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceBreakdownCard.vue?vue&type=style&index=0&id=9615755c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9615755c",
  null
  
)

export default component.exports